import { call, put, takeEvery } from "redux-saga/effects";
import { getGiftMilesDropdownFailure, getGiftMilesDropdownRequest, getGiftMilesDropdownSuccess, getGiftMilesReceiptDownloadRequest, getGiftMilesReceiptDownloadFailed, getGiftMilesReceiptDownloadSuccess, giftMilesPaymentInitFailure, giftMilesPaymentInitRequest, giftMilesPaymentInitSuccess, reviewSummaryFailure, reviewSummaryRequest, reviewSummarySuccess } from "../slice/giftMilesSlice";
import api from "../../../config/api";
import { config } from "../../../config/global";
const accessToken = localStorage.getItem("accesstoken");
const memberId = sessionStorage.getItem("memberId");
const headerData = {
  mode: "no-cors",
  headers: {
    "content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "App-Authorization": accessToken || "",
    memberId
  }
};
const fetchDropdownData = async () => {
  const DROPDOWN_API_URL = config?.FETCH_GIFT_MILES_DROPDOWN;
  const response = await api.get(DROPDOWN_API_URL, headerData);
  return response;
};
const fetchReviewSummary = async payload => {
  const REVIEW_SUMMARY_URL = config?.ROP_REVIEW_SUMMARY_GIFT_MILES;
  let payloadData = {
    firstNameMiddleName: payload?.firstName,
    lastName: payload?.lastName,
    giftingMiles: payload?.giftingMiles,
    currency: payload?.currency,
    sponseeId: payload?.receipientROPId
  };
  const response = await api.post(REVIEW_SUMMARY_URL, payloadData, headerData);
  return response;
};
const fetchGiftMilesPaymentInit = async payload => {
  const response = await api.post(payload, headerData);
  return response;
};
const fetchGiftMilesReceiptDownload = async payload => {
  const DOWNLOAD_URL = config?.ROP_GIFT_MILES_DOWNLOAD_RECEIPT;
  const response = await api.post(DOWNLOAD_URL, payload, headerData);
  return response;
};
function* getDropdownData() {
  try {
    const response = yield call(fetchDropdownData);
    yield put(getGiftMilesDropdownSuccess(response?.data));
  } catch (error) {
    yield put(getGiftMilesDropdownFailure(error.message));
  }
}
function* getReviewSummary(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchReviewSummary, payload);
    yield put(reviewSummarySuccess(response?.data));
  } catch (error) {
    yield put(reviewSummaryFailure(error));
  }
}
function* getGiftMilesPaymentInit(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchGiftMilesPaymentInit, payload);
    yield put(giftMilesPaymentInitSuccess(response?.data));
  } catch (error) {
    yield put(giftMilesPaymentInitFailure(error));
  }
}
function* getGiftMilesReceiptDownload(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchGiftMilesReceiptDownload, payload);
    yield put(getGiftMilesReceiptDownloadSuccess(response?.data));
  } catch (error) {
    yield put(getGiftMilesReceiptDownloadFailed(error));
  }
}
export function* watchGiftMilesDropdownData() {
  yield takeEvery(getGiftMilesDropdownRequest.type, getDropdownData);
}
export function* watchGiftMilesReviewSummaryData() {
  yield takeEvery(reviewSummaryRequest.type, getReviewSummary);
}
export function* watchGiftMilesPaymentInit() {
  yield takeEvery(giftMilesPaymentInitRequest.type, getGiftMilesPaymentInit);
}
export function* watchGiftMilesReceiptDownload() {
  yield takeEvery(getGiftMilesReceiptDownloadRequest.type, getGiftMilesReceiptDownload);
}